import {
    GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS,
    GETCUSTOMERIDANDNAMELISTADMIN_FAILED,
    RESET_GETCUSTOMERIDANDNAMELISTADMIN,
    LOADING_GETCUSTOMERIDANDNAMELISTADMIN,
    NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetCustomerIdAndNamesList = () => {
    return { type: RESET_GETCUSTOMERIDANDNAMELISTADMIN };
};

const AdmingetCustomerIDNAMELists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCUSTOMERIDANDNAMELISTADMIN });
    await adminServices
        .post("getCustomerIdAndNameListAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetCustomerIdNameListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetCustomerIdNameListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETCUSTOMERIDANDNAMELISTADMIN,
                payload: err
            });
        });
};


function AdminGetCustomerIdNameListsuccess(data) {
    return {
        type: GETCUSTOMERIDANDNAMELISTADMIN_SUCCESS,
        payload: data
    };
}
function AdminGetCustomerIdNameListFailed(data) {
    return {
        type: GETCUSTOMERIDANDNAMELISTADMIN_FAILED,
        payload: data
    };
}

export { AdmingetCustomerIDNAMELists, resetAdminGetCustomerIdAndNamesList }